import { connect } from "react-redux";
import EditCorporate from "./editCorporate";
import { bindActionCreators } from "redux";
import { LeadSource } from "services/redux/sales/corporate/leadDetails/action";
import { pocType } from "services/redux/sales/corporate/pocDetails/action";
import {
  leadCategories,
  rwaTenureFun,
  supplyNameFun,
  getCorporateDropDown,
} from "services/redux/sales/corporate/categoryDetails/action";

import {
  locationArea,
  locationCity,
  locationPinCode,
  locationState,
  locationType,
  locationZone,
} from "services/redux/sales/corporate/locations/action";
import { getCurrentLocation } from "services/redux/sales/currentLocation/action";
import { excelUploadUrl } from "services/redux/fileUpload/action";
import { getDetails } from "services/redux/sales/preSaleListing/action";
import { editCorporateLeadSubmit } from "services/redux/sales/editLead/action";

const mapStateToProps = (state) => ({
  sourceData: state.LeadDetailsReducer.LeadSources,
  pocTypeData: state.pocTypesReducer.pocTypeData,
  leadCategory: state.categoryDetlReducer.leadCategory,
  rwaTenureData: state.categoryDetlReducer.rwaTenureData,
  splNameData: state.categoryDetlReducer.splNameData,
  cities: state.locationReducer.cities,
  zones: state.locationReducer.zones,
  areas: state.locationReducer.areas,
  state: state.locationReducer.state,
  pincodeData: state.locationReducer.pincodeData,
  locTypesData: state.locationReducer.locTypesData,
  corDropDownData: state.categoryDetlReducer.corDropDownData,
  latlng: state.currentLocationReducer.latlng,
  toastMsg: state.toastReducer,
  viewDetails: state.preSalesListReducer.viewDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      LeadSource,
      pocType,
      leadCategories,
      locationCity,
      locationZone,
      locationArea,
      locationType,
      locationState,
      editCorporateLeadSubmit,
      locationPinCode,
      supplyNameFun,
      rwaTenureFun,
      getCorporateDropDown,
      getCurrentLocation,
      excelUploadUrl,
      getDetails,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EditCorporate);
